import React from 'react';
export default function GeneralSiteInspection() {
  return <></>;
}
